import { NAT_GATEWAY } from 'constant';
import { enumToArray, _t } from 'utils';
import { formField } from 'types';

const setPortVisibility = ({ protocol }) => protocol === NAT_GATEWAY.PROTOCOL.TCP || protocol === NAT_GATEWAY.PROTOCOL.UDP;
const style = { marginTop: 10, fontSize: 16, color: 'gray' };

const fields = [
  formField.text({ name: 'name', title: _t('Name') }),
  formField.dropdown({ name: 'type', title: 'Type', options: enumToArray(NAT_GATEWAY.RULE, NAT_GATEWAY.RULE_TITLE) }),
  formField.dropdown({ name: 'protocol', title: 'Protocol', options: enumToArray(NAT_GATEWAY.PROTOCOL) }),
  formField.label({ name: 'source', title: 'Source', style }),
  formField.dropdown({ name: 'publicIp', title: 'Public IP' }),
  formField.text({ name: 'sourceSubnet', title: 'Source IP with Subnet' }),
  formField.label({ name: 'target', title: 'Target', style }),
  formField.text({ name: 'targetSubnet', title: 'Target IP with Subnet' }),
  formField.object({
    name: 'targetPortRange',
    title: 'Target Port Range',
    setVisibility: setPortVisibility,
    fields: [
      formField.port({ name: 'start', title: 'Start Port' }),
      formField.port({ name: 'end', title: 'End Port' }),
    ],
  }),
];

const fieldsValues = {
  protocol: NAT_GATEWAY.PROTOCOL.ALL,
  type: NAT_GATEWAY.RULE.SNAT,
  targetPortRange: {},
};

export default {
  fields,
  fieldsValues,
};
